/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.14.0
 */

import { ReactNode } from 'react';

import { Button } from '../../../components/common';
import { ImgStatusSuccess } from '../../../components/common/Block/Img';
import { ICorporateModal } from '../../internationalization/types/corporate';
import { IModalRenderProps } from '../types/modalTypes';
import Modal from './Modal';
import { ModalCenterStyled } from './styled/ModalCenterStyled';

interface IModalSuccess extends Pick<IModalRenderProps, 'onCloseModal'> {
    btn?: string;
    children?: ReactNode;
    title: string;
    translation: ICorporateModal;
}

const ModalSuccess = ({ btn, children, title, translation, onCloseModal }: IModalSuccess) => {
    return (
        <Modal dataName="modal-success" width="580px">
            <ModalCenterStyled>
                <ImgStatusSuccess/>
                <Modal.Title>
                    {title}
                </Modal.Title>
                {children}
                <Modal.Control>
                    <Button kind="medium" onClick={onCloseModal}>{btn || translation.good}</Button>
                </Modal.Control>
            </ModalCenterStyled>
        </Modal>
    );
};

export default ModalSuccess;
